<template>
    <div>
        <Formulario :data="data" :loginModal="modalLogin" @solicitaCodigo="solicitaCodigo"/>
        <CodigoAutenticacao ref="codigoAutenticacao" :data="data" :codigoModal="codigoModal" @solicitaCodigo="solicitaCodigo" @voltarCodigo="voltarCodigo" @tokenInserido="login"/>
    </div>
</template>

<script>
import '@/shared/plugins/recaptcha'
import { mapState, mapActions } from 'vuex'
import Formulario from './Formulario'
import CodigoAutenticacao from './CodigoAutenticacao'

export default {
    name: 'Login',
    components: {
        Formulario,
        CodigoAutenticacao
    },
    data() {
        return {
            data: {
                inputCodigo: '',
                inputLogin: '',
                timer: 0,
            },
            codigoModal: false,
            loginModal: false
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    computed: {
        ...mapState('usuarios', ['usuarioLogado', 'modalLogin']),
    },
    methods: {
        ...mapActions('usuarios', {
            xLogin: 'login',
            carregaUsuarioLogado: 'carregaUsuarioLogado',
            xLogout: 'logout'
        }),
        async enviaToken() {
            this.reenviar = false
            this.$loading.show()
            const dados = {
                Acesso: {
                    telefone: this.data.inputLogin.trim(),
                    empresa_id: this.$dadosLoja.LojasConfiguracaoAgendaPro.empresa_id,
                    loja_id: this.$dadosLoja.LojasConfiguracaoAgendaPro.loja_id
                },
                slug: this.$dadosLoja.LojasConfiguracaoAgendaPro.slug
            }
            const res = await this.$api.post('/agenda_pro/meus_agendamentos/envia_codigo', dados)
            this.$refs.codigoAutenticacao.reenviar = false
            this.data.timer = res.data ? res.data : 0
            if(res.status != 'success'){
                this.$notify.warning(res.message)
            }
            this.$loading.hide()
        },
        async login(token = null) {
            if (!token) {
                this.$dialog.error('Código de acesso inválido.')
            }
            const validado = await this.$validator.validateAll()
            if (!validado) {
                return false
            }
            this.$loading.show()
            const recaptcha = await this.$recaptcha('login')
            const dados = {
                'Acesso': {
                    'empresa_id': this.$dadosLoja.LojasConfiguracaoAgendaPro.empresa_id,
                    'loja_id': this.$dadosLoja.LojasConfiguracaoAgendaPro.loja_id,
                    'telefone': this.data.inputLogin.trim(),
                    'codigo': token
                },
                'g-recaptcha-response': recaptcha
            }
            const login = await this.xLogin(dados)
            if (login.status == 'success') {
                location.reload(true)
            } else {
                this.$notify.error(login.message)
                this.$loading.hide()
            }
        },
        async solicitaCodigo() {
            if (this.verificar()) {
                this.enviaToken();
                this.codigoModal = true
                this.loginModal = false
            }
        },
        voltarCodigo() {
            this.codigoModal = false
            this.loginModal = true
        },
        verificar() {
            const value = this.data.inputLogin.trim()
            if (!this.isPhoneNumber(value)) {
                this.$dialog.error('Insira um telefone válido.')
                return false
            }
            return true
        },
        isPhoneNumber(input) {
            const phoneRegex = /^\(\d{1,2}\)\d{5}-\d{4}$/
            return phoneRegex.test(input)
        }
    }
}
</script>
